<div *ngIf="control" class="as-input-container" [ngClass]="customClass">
  <label *ngIf="label" class="input-label">{{ label }}</label>
  <input
    [formControl]="control"
    [type]="type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [ngClass]="size"
    [pattern]="pattern"
    [value]="value"
    [minlength]="minlength"
    (input)="onInput($event)"
    (change)="onChangeF($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
  />
</div>
<div *ngIf="!control" class="as-input-container" [ngClass]="customClass">
  <label *ngIf="label" class="input-label">{{ label }}</label>
  <input
    [(ngModel)]="value"
    [type]="type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [ngClass]="size"
    [pattern]="pattern"
    [minlength]="minlength"
    (input)="onInput($event)"
    (change)="onChangeF($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
  />
</div>